import { EventCard } from "../../../components";
import * as RenderMethods from "./RenderMethods";

export class American extends EventCard {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.cardTypeClass = "rj-ev-list__ev-card--american";
        this.buttonsHolderClass = "rj-ev-list__ev-card__buttons-holder--american";
    }

    renderMarkets = RenderMethods.renderMarketsAmerican;
}